var toolbarRadioGroupStyles = {
  root: function root() {
    return {
      whiteSpace: 'nowrap'
    };
  }
};
export default toolbarRadioGroupStyles;